//  ----------      START   IMPORT  BLOCK       ----------
import { useState } from 'react';
import { Container, Row, Col, Card, Collapse, Button } from 'react-bootstrap';
import { 
  FaInstagram, FaTiktok, FaTwitter, FaYoutube, 
  FaExternalLinkAlt, FaEnvelope, FaChevronUp 
} from 'react-icons/fa';
//  Context
import { useLanguage } from '../../../../../API/Context/LanguageContext';
//  Config
import { FRONTEND_ROUTES } from '../../../../../ConfigFiles/Routes/frontend_routes';
import { VocabSocials } from '../../../../../ConfigFiles/multilingual/VocabSocials';
import ContactWidget from '../ContactWidget/ContactWidget';
import './SocialsWidget.css';
//  ----------      END   IMPORT  BLOCK       ----------

const SocialsWidget = () => {
  //  Consume context
  const { lan } = useLanguage();

  const [showContact, setShowContact] = useState(false);

  const socialLinks = [
    { name: 'Instagram', icon: <FaInstagram/>, link: FRONTEND_ROUTES.SOCIAL_INSTA, color: '#E1306C' },
    { name: 'TikTok', icon: <FaTiktok/>, link: FRONTEND_ROUTES.SOCIAL_TIKTOK, color: '#000000' },
    { name: 'Twitter', icon: <FaTwitter/>, link: FRONTEND_ROUTES.SOCIAL_TWITTER, color: '#1DA1F2' },
    { name: 'YouTube', icon: <FaYoutube/>, link: FRONTEND_ROUTES.SOCIAL_YOUTUBE, color: '#FF0000' },
  ];

  return (
    <Container className="py-5" style={{ maxWidth: '500px' }}>
        <h5 className="mb-4 text-center">{VocabSocials.connect_with_us[lan]}</h5>
        
        <Row className="g-3">
          {/* --- Social Tiles --- */}
          {socialLinks.map((social, index) => (
            <Col xs={6} key={index}>
              <a href={social.link} target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                <Card className="social-card bento-tile h-100 border-0 shadow-sm">
                  <Card.Body className="d-flex flex-column align-items-center justify-content-center p-4">
                    <div className="social-icon-wrapper mb-2" style={{ color: social.color }}>
                      {social.icon}
                    </div>
                    <div className="social-name">{social.username || '@medcleir'}</div>
                    <FaExternalLinkAlt className="external-hint" />
                  </Card.Body>
                </Card>
              </a>
            </Col>
          ))}

          {/* --- Contact Trigger Tile --- */}
          <Col xs={12}>
            <Card 
              className={`contact-trigger-card bento-tile border-0 shadow-sm ${showContact ? 'active' : ''}`}
              onClick={() => setShowContact(!showContact)}
              role="button"
            >
              <Card.Body className="d-flex align-items-center justify-content-center py-3 gap-3">
                <FaEnvelope className={showContact ? 'text-primary' : ''} />
                <span className="fw-bold">
                  {VocabSocials.message_tittle[lan]}
                </span>
                <FaChevronUp className={`transition-icon ${showContact ? '' : 'rotate-180'}`} />
              </Card.Body>
            </Card>
          </Col>

          {/* --- Contact Form Expansion --- */}
          <Col xs={12}>
            <Collapse in={showContact}>
              <div>
                <div className="mt-2">
                   <ContactWidget />
                </div>
              </div>
            </Collapse>
          </Col>
        </Row>
      </Container>
  );
};

export default SocialsWidget;